import React from "react";
import { MessageCircle } from "lucide-react";
import { WHATSAPP, openExternal } from "@/lib/contact";

export default function WhatsAppFab() {
  return (
    <a
      data-testid="whatsapp-fab"
      href={WHATSAPP}
      target="_blank"
      rel="noreferrer"
      onClick={(e) => openExternal(e, WHATSAPP)}
      className="fixed bottom-5 right-5 z-50 group"
      aria-label="WhatsApp 3D Print Hub"
    >
      <span className="absolute inset-0 rounded-full bg-[#FF5722] opacity-50 group-hover:opacity-70 animate-ping" />
      <span className="relative w-14 h-14 rounded-full bg-[#FF5722] grid place-items-center shadow-lg shadow-[#FF5722]/30 group-hover:bg-[#F4511E] transition-colors">
        <MessageCircle size={22} className="text-white" />
      </span>
    </a>
  );
}
